(ns frontend.view.settings2.e-signature.test-view
  (:require [clojure.edn :as edn]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.db :as app-db]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.ui.component.label.view :refer [label]]
            [frontend.view.components.clipboard :as clipboard]
            [frontend.view.modals.components.processing-modal :as processing-modal]
            [frontend.view.modals.events :as modals]
            [frontend.view.not-found :as not-found]
            [frontend.view.settings2.e-signature.events :as events]
            [frontend.view.settings2.e-signature.sub :as sub]
            [frontend.view.settings2.sales-pipelines.db :as db]
            [common.schema.entities.esign-process-status :as esign-process-status]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [frontend.subscription :as subscription]
            [ui.color :as c]
            [ui.components.breadcrumbs.view :as breadcrumbs]
            [common.schema.entities.signatory :as signatory-schema]
            [ui.components.button.view :as button]
            [common.schema.entities.pipeline :as pipeline]
            [ui.components.link.view :as link]
            [ui.components.modal.view :as modal]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.select.select :as select]
            [ui.editors.labelled-input.view :as labelled-input]
            [frontend.ui.component.file-input.view :as file-input]
            [oops.core :as oops]
            [frontend.state.current-session :as current-session]
            [common.entity :as entity]

            [frontend.actions.attachment :as attachment-actions]
            [frontend.actions.common :as common-actions]

            [frontend.conn :as conn]
            [frontend.logging :as logging]
            [promesa.core :as p]
            [potpuri.core :as potpuri]
            [frontend.utils :as fu]
            [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
            [ui.util :as uu]
            ["react-hot-toast" :default toast :refer (Toaster)]
            [clojure.string :as string]))

(defn info-toast
  [message]
  (toast message))

(defn success-toast
  [message]
  (oops/ocall toast "success" message))

(defn error-toast
  [message]
  (oops/ocall toast "error" message))

(defn upload-file!
  [file on-success]
  (let [filename (oops/oget file "name")
        attachment {:filename    filename
                    :description ""
                    :file        file}
        on-success! (fn [token]
                      (attachment-actions/*=>add-attachment
                       {:multipart-params (assoc attachment :token token)
                        :progress         (fn [prog])}
                       (fn [resp]
                         (-> resp
                             :body
                             :db/id
                             on-success))
                       (fn [err]
                         (js/console.log "Error file upload " err))))]
    (common-actions/*<-create-op-token nil
                                       on-success!
                                       (fn [err]
                                         (js/console.log "op error " err)))))

(defn create-esign-process!
  [data on-success! on-error!]
  (-> (conn/sendp! :esign-v2/create data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn remind-signatory!
  [data on-success! on-error!]
  (-> (conn/sendp! :esign-v2/remind data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn retry-start-process!
  [process-id]
  (-> (conn/sendp! :esign-v2/retry-start-process {:esign-process-id process-id})
      (p/then (fn [resp]
                (js/console.log "Retry success " resp)))
      (p/catch (fn [err]
                 (error-toast (or (:message err) "An error happened"))
                 (js/console.log "Retry error " err)))))

(defn cancel-esign-process!
  [data on-success! on-error!]
  (-> (conn/sendp! :esign-v2/cancel data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn resolve-provider-for-target-entity
  [target-id]
  (let [target-entity (get @session/entities target-id)
        pipeline (pipeline/pipeline target-entity)
        credentials (:tenant/esign-api-credentials @session/tenant)
        credential
        (->> credentials
             (filterv
              (fn [credential]
                (->> credential
                     :targets
                     (filterv
                      (fn [credential-target]
                        (if pipeline
                          (= (:db/id credential-target) pipeline)
                          (= (:entity/type credential-target) (:entity/type target-entity)))))
                     (seq))))
             first)]
    (:provider credential)))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:settings/e-signature]))}
    (loc/tr :settings/e-signature)]

   [breadcrumbs/item
    {:active? true}
    "E-Sign test page"]])

(defn creator-modal
  [state*]
  (let [submitting? (:submitting? @state*)
        form-state (get @state* :form)
        target-id (:target-id form-state)
        file (:file form-state)
        signatories (:signatories form-state)

        provider (when target-id
                   (resolve-provider-for-target-entity target-id))

        submit-disabled? (or submitting?
                             (not target-id)
                             (not file)
                             (not signatories)
                             (empty? signatories)
                             (and target-id (not provider)))

        esign-configured-for-entity-types
        (->> @session/tenant
             :tenant/esign-api-credentials
             (mapcat (fn [cred]
                       (->> cred
                            :targets
                            (mapv :entity/type)
                            (remove #(= % :entity.type/pipeline)))))
             (mapv loc/tr)
             sort)

        esign-configured-for-pipelines
        (->> @session/tenant
             :tenant/esign-api-credentials
             (mapcat (fn [cred]
                       (->> cred
                            :targets
                            (cu/filter-by :entity/type :entity.type/pipeline)
                            (mapv :db/id))))
             (mapv (fn [pipeline-id]
                     (let [pipeline (session/get-entity pipeline-id)
                           pipeline-name (:pipeline/name pipeline)
                           target-type (:pipeline/entity-type pipeline)]
                       (str pipeline-name " (" (loc/tr target-type) ")")))))

        submit (fn []
                 (swap! state* assoc
                        :submitting? true)
                 (let [file (get-in @state* [:form :file])
                       target-id (get-in @state* [:form :target-id])
                       signatories (get-in @state* [:form :signatories])]
                   (info-toast "Submitting...")
                   (upload-file!
                    file
                    (fn [file-id]
                      (create-esign-process!
                       {:target-id target-id
                        :attachment-id file-id
                        :signatories signatories}
                       (fn [resp]
                         (let [esign-process-id (-> resp
                                                    :body
                                                    :esign-process-id)
                               entities (-> resp
                                            :body
                                            :entities)
                               entities-by-id (potpuri/index-by :db/id entities)]
                           (js/console.log "REsP " resp)
                           (swap! state* update :entities merge entities-by-id)
                           (swap! state* assoc
                                  :submitting? false
                                  :modal-open? false
                                  :latest-started-process-id esign-process-id
                                  :form {:target-id nil
                                         :file nil
                                         :signatories [{:name "" :email ""}]})))
                       (fn [err]
                         (js/console.log "ERRORRR" err)
                         (swap! state* assoc :submitting? false)
                         (error-toast (or (:message err) "An error happened"))))))))]
    [modal/view
     {:visible? (:modal-open? @state*)}
     [:div "Create new E-Sign process"]
     [:div
      {:class "flex flex-col gap-8"}
      [:div
       {:class "flex flex-col gap-1"}
       [labelled-input/view
        {:editor-type :editor.type/search
         :data-type :data.type/ref-single
         :label "Select target entity"
         :value (when-let [target-id (get-in @state* [:form :target-id])]
                  {:value target-id
                   :label (-> target-id
                              current-session/get-entity
                              entity/display-string)})
         :on-change (fn [value]
                      (swap! state* assoc-in [:form :target-id] value))
         :field/entity-types [:entity.type/sale-agreement
                              :entity.type/oppo
                              :entity.type/sales-opportunity]}]

       [:div
        {:class "text-sm m-0 text-base-ligh-text-paler"}
        [:p (str "Esign configured for entity types: " (string/join ", " esign-configured-for-entity-types))]
        [:p (str "Esign configured for pipelines: " (string/join ", " esign-configured-for-pipelines))]]]

      [:div
       {:class "flex flex-col"}
       [:div "Document to sign"]
       [:div
        {:class "flex gap-2"}

        ^{:key (str (get-in @state* [:rerender-counter]))}
        [:input
         {:type "file"
          :accept ".pdf"
          :on-change (fn [e]
                       (let [file (-> e
                                      (oops/oget "target")
                                      (oops/oget "files")
                                      (aget 0))]
                         (swap! state* assoc-in [:form :file] file)))}]

        (when (get-in @state* [:form :file])
          [button/sm-secondary-hollow
           {:on-click (fn []
                        (swap! state* assoc-in [:form :file] nil)
                        (swap! state* update-in [:rerender-counter] (fnil inc 0)))}
           "Remove file"])]]

      [:div
       {:class "flex flex-col gap-2"}
       [:p "Signatories"]

       [:div
        {:class "flex flex-col gap-2"}
        (->> (get-in @state* [:form :signatories])
             (map-indexed (fn [idx {:keys [name email]}]
                            [:div
                             {:class "flex gap-2 items-center"}
                             [:div
                              {:class "grow"}
                              [labelled-input/view
                               {:label (str "Signatory " (inc idx) " name")
                                :value name
                                :data-type :data.type/text-simple
                                :on-change #(swap! state* assoc-in [:form :signatories idx :name] %)}]]
                             [:div
                              {:class "grow"}
                              [labelled-input/view
                               {:label (str "Signatory " (inc idx) " email")
                                :value email
                                :data-type :data.type/text-simple
                                :on-change #(swap! state* assoc-in [:form :signatories idx :email] %)}]]

                             [:div
                              [button/sm-secondary-hollow
                               {:on-click #(swap! state* update-in [:form :signatories] (partial cu/vec-remove idx))}
                               "Remove"]]])))

        [:div
         [button/sm-secondary-hollow
          {:on-click #(swap! state* update-in [:form :signatories] (fnil conj []) {:name ""
                                                                                   :email ""})}
          "Add signatory"]]]]]
     [:<>
      [button/sm-secondary-hollow
       {:on-click #(swap! state* assoc :modal-open? false)
        :disabled? submitting?}
       "Cancel"]

      (when target-id
        (if provider
          [:p (str "This process will be done via " (loc/tr provider))]
          [:p "No esign provider found for target entity. Please contact admin."]))

      [button/sm-primary-solid
       {:on-click submit
        :disabled? submit-disabled?}
       "Create!"]]]))

(defn header
  [state*]
  [:div
   {:class "flex justify-between"}
   [:p
    {:class "font-semibold"}
    "E-Sign Test Page"]

   [button/sm-primary-solid
    {:on-click #(swap! state* assoc :modal-open? true)}
    "Create new E-Sign process"]])

(defn actions-dropdown
  [items]
  [dropdown-menu/view
   {:items items
    :props {:align :end}
    :trigger-as-child
    [:span
     [button/square-secondary-hollow
      {}
      [:i
       {:class "fal fa-ellipsis-v"}]]]}])

(defn signatory-table
  [{:keys [process state*]}]
  (let []
    [:table
     {:class "border-collapse border"}
     [:thead
      [:tr
       [:th
        {:class "border bg-base-regular p-2"
         :col-span 5}
        "Signatories"]]
      [:tr
       [:th
        {:class "border bg-base-regular p-2"}
        "Name"]
       [:th
        {:class "border bg-base-regular p-2"}
        "Email"]
       [:th
        {:class "border bg-base-regular p-2"}
        "Reminder sent"]
       [:th
        {:class "border bg-base-regular p-2"}
        "Sign Status"]
       [:th
        {:class "border bg-base-regular"}]]]
     [:tbody
      (->> process
           :esign-process/signatories
           (map (fn [signatory-id]
                  (let [signatory (get-in @state* [:entities signatory-id])
                        {:signatory/keys [name email sign-status last-reminded-on]} signatory]
                    ^{:key (str signatory-id)}
                    [:tr
                     [:td
                      {:class "border p-2"}
                      name]
                     [:td
                      {:class "border p-2"}
                      email]
                     [:td
                      {:class "border p-2"}
                      (if last-reminded-on
                        (fu/format-datetime-ts last-reminded-on)
                        "-")]
                     [:td
                      {:class "border p-2"}
                      (signatory-schema/get-sign-status-label sign-status)]
                     [:td
                      {:class "border p-2"}
                      (when-not (= sign-status :signatory.sign-status/signed)
                        [:div
                         {:class "flex items-center justify-center"}
                         [actions-dropdown
                          [{:label "Send reminder"
                            :icon-class "fal fa-bell"
                            :on-click
                            (fn []
                              (remind-signatory!
                               {:signatory-id signatory-id
                                :esign-process-id (:db/id process)}
                               (fn [resp]
                                 (js/console.log "Remind success" resp)
                                 (success-toast "Reminder sent"))
                               (fn [resp]
                                 (js/console.log "Remind error " resp)
                                 (error-toast (or (:message resp) "An error happened")))))}]]])]])))
           (doall))]]))

(defn document-item
  [attachment]
  [:div
   {:class "rounded border shadow px-3 py-2 flex items-center justify-between gap-2"}
   [:div
    {:class "flex items-center gap-2"}
    [:i
     {:class "fal fa-file-pdf"}]
    (:attachment/filename attachment)]

   [:div
    {:class "flex gap-2 items-center"}
    [button/square-secondary-hollow
     {:tooltip "View document"
      :on-click #(fu/open-attachment! (:db/id attachment))}
     [:i {:class "fal fa-external-link"}]]
    [button/square-secondary-hollow
     {:tooltip "Download document"
      :on-click #(fu/download-attachment! (:db/id attachment))}
     [:i {:class "fal fa-cloud-download"}]]]])

(defn process-item
  [{:keys [process state*]}]
  (let [get-entity (fn [entity-id]
                     (get (merge (:entities @state*) @session/entities) entity-id))
        target-label (-> process
                         :esign-process/target
                         get-entity
                         entity/display-string)
        status (-> process
                   :esign-process/status)


        expanded? (get-in @state* [:expanded (:db/id process)])
        ;;expanded? true

        toggle-expanded #(swap! state* update-in [:expanded (:db/id process)] not)

        unsigned-document (->> process
                               :common/attachments
                               (mapv (fn [id]
                                       (get-in @state* [:entities id])))
                               (filterv (fn [a]
                                          (some (set (:common/system-kws a)) [:esign-attachment/unsigned])))
                               first)

        signed-document (->> process
                             :common/attachments
                             (mapv (fn [id]
                                     (get-in @state* [:entities id])))
                             (filterv (fn [a]
                                        (some (set (:common/system-kws a)) [:esign-attachment/signed])))
                             first)

        signed? (= status :esign-process.status/signed)
        declined? (= status :esign-process.status/declined)
        processing? (some #{:esign-process.status/not-started
                            :esign-process.status/started
                            :esign-process.status/document-uploaded} [status])

        failed? (= status :esign-process.status/failed)

        status-label (if processing?
                       "Processing..."
                       (esign-process-status/get-label status))

        status-label (esign-process-status/get-label status)

        status-label (case status
                       :esign-process.status/not-started
                       "Processing..."
                       :esign-process.status/started
                       "Uploading content..."
                       :esign-process.status/document-uploaded
                       "Sending to signatories..."

                       (esign-process-status/get-label status))
        provider-label (loc/tr (:esign-process/provider process))]
    [:div
     {:class "flex flex-col gap-5 px-2 py-5 border border-x-0 border-t-0"}
     [:div
      {:class "flex gap-2 py-3 items-center justify-between group/header"}
      [:p
       {:class "font-bold cursor-pointer hover:underline"
        :on-click toggle-expanded}
       target-label]

      [:p
       {:class "text-sm text-base-light-text-paler m-0"}
       (str "ID: " (:db/id process))]

      [:p
       {:class "text-sm m-0 text-base-light-text-paler"}
       (str "Created: " (fu/format-datetime-ts (:common/created-on process)))]

      [:p
       {:class "text-sm text-base-ligh-text-paler m-0"}
       (str provider-label (when (:esign-process/last-synced-on process)
                             (str " - last synced at "
                                  (fu/format-datetime-ts (:esign-process/last-synced-on process)))))]

      [:div
       {:class "flex gap-3 items-center"}
       [:div
        {:class (uu/cm "rounded-full border px-3 py-1 flex items-center gap-2"
                       (case status
                         :esign-process.status/signed
                         "bg-primary-regular"

                         :esign-process.status/declined
                         "bg-danger-regular"

                         :esign-process.status/failed
                         "bg-danger-regular"
                         ""))}
        (case status
          :esign-process.status/signed
          [:i {:class "fal fa-check"}]

          :esign-process.status/declined
          [:i {:class "fal fa-times text-danger-regular-text"}]

          :esign-process.status/sent
          [:i {:class "fal fa-envelope"}]

          :esign-process.status/failed
          [:i {:class "fal fa-exclamation-triangle text-danger-regular-text"}]


          nil)
        [:span
         {:class (uu/cm "text-sm m-0 font-semibold"
                        (when (or failed? declined?)
                          "text-danger-regular-text"))}
         status-label]]

       [actions-dropdown
        (concat
         (when true #_failed?
               [{:label "Retry starting process"
                 :on-click #(retry-start-process! (:db/id process))}])

         [{:label "Cancel E-Sign process"
           :on-click (fn []
                       (cancel-esign-process!
                        {:esign-process-id (:db/id process)}
                        (fn [resp]
                          (success-toast "Cancelled succesfully")
                          (js/console.log "success cancel " resp))
                        (fn [err]
                          (js/console.log "error canceling " err)
                          (error-toast (or (:message err) "Unknown error happened")))))}

          {:label "Sync process state"
           :on-click (fn []
                       (-> (conn/sendp! :esign-v2/sync-process-state
                                        {:esign-process-id (:db/id process)})
                           (p/then (fn [resp]
                                     (js/console.log "Success resp" resp)
                                     (success-toast "Synced succesfully")))
                           (p/catch (fn [error]
                                      (js/console.log "Error syncing " error)
                                      (error-toast (or (:message error) "Unknown error happened"))))))}

          {:label "Delete process"
           :on-click (fn []
                       (let [process-id (:db/id process)]
                         (-> (conn/sendp! :esign-v2/delete
                                          {:esign-process-id (:db/id process)})
                             (p/then (fn [resp]
                                       (js/console.log "Success resp" resp)
                                       (success-toast "Deleted succesfully")
                                       (swap! state* potpuri/dissoc-in [:entities process-id])))
                             (p/catch (fn [error]
                                        (js/console.log "Error deleting " error)
                                        (error-toast (or (:message error) "Unknown error happened while deleting")))))))}])]]]

     (when expanded?
       [:div
        {:class "flex flex-col gap-10"}

        (when failed?
          [:div (str "Failed reason: " (:esign-process/fail-reason process))])

        (case (:esign-process/provider process)
          :oneflow
          [:div (str "Oneflow contract id: " (:esign-process/oneflow-document-id process))]

          :docusign
          [:div (str "Docusign envelope id: " (:esign-process/docusign-envelope-id process))]

          nil)

        [:div
         {:class "grid grid-cols-2 gap-10"}
         [:div
          {:class "flex flex-col gap-2"}
          [:p
           {:class "font-semibold"}
           "Unsigned document"]

          [document-item unsigned-document]]

         [:div
          {:class "flex flex-col gap-2"}
          [:p
           {:class "font-semibold"}
           "Signed document"]

          (case status
            :esign-process.status/signed
            (if signed-document
              [document-item signed-document]
              [:div
               {:class "text-sm text-base-light-text-paler"}
               "Loading signed contract, please wait..."])

            :esign-process.status/declined
            [:div
             {:class "text-sm text-base-light-text-paler"}
             "The process was declined by signer"]

            [:div
             {:class "text-sm text-base-light-text-paler"}
             "Signed document will be here when ready"])]]
        [signatory-table
         {:process process
          :state* state*}]])]))

(defn esign-process-list
  [state*]
  (let [entities (:entities @state*)
        processes (->> entities
                       (vals)
                       (cu/filter-by :entity/type :entity.type/esign-process)
                       (sort-by :common/created-on)
                       (reverse))]
    [:div
     {:class "flex flex-col gap-2"}
     (->> processes
          (map (fn [{:keys [db/id] :as process}]
                 ^{:key (str id)}
                 [:div
                  [process-item
                   {:process process
                    :state* state*}]])))]))

(defn component
  []
  (let [state* (r/atom {:modal-open? false
                        :entities {}
                        :expanded {}
                        :form {:target-id nil
                               :file      nil
                               :signatories [{:name "Tuukka One"
                                              :email "tuukka.pori+sign1@zapflow.com"}]}})]
    (r/create-class
     {:component-did-mount    (fn []
                                (subscription/open
                                 ::esign-test
                                 :view-subscription/esign-v2-test-view
                                 {}
                                 (fn [{:keys [entities initial-data?] :as data-update}]
                                   (let [entities-by-id (potpuri/index-by :db/id entities)
                                         latest-started-process-id (:latest-started-process-id @state*)
                                         sent? (->> entities
                                                    (filterv (fn [{:keys [db/id esign-process/status]}]
                                                               (and (= id latest-started-process-id)
                                                                    (= status :esign-process.status/sent))))
                                                    seq)]
                                     (swap! state* update :entities merge entities-by-id)
                                     (when sent?
                                       (success-toast "Sent to signatories!")
                                       (swap! state* dissoc :latest-started-process-id)))
                                   :ok)
                                 (fn [err]
                                   (js/console.log "ERRORRR " err))))
      :component-will-unmount (fn []
                                (subscription/close ::esign-test))
      :reagent-render
      (fn []
        [:<>
         [zap-toolbar/view db/state breadcrumbs nil []]
         [:div
          {:class "h-[calc(100vh_-_52px-_37px)] overflow-hidden w-6xl max-w-full mx-auto px-5"}
          [:div
           {:class "flex flex-col h-full max-h-full overflow-hidden"}
           [:div
            {:class "py-2"}
            [header state*]]

           [:div
            {:class "grow overflow-hidden overflow-y-auto pb-10 px-2"}
            [esign-process-list state*]]

           [creator-modal state*]]]])})))

;; TODO: This view can be deleted after new esign is confirmed to be working
(defmethod routing/render-view :settings/e-signature-test
  [_]
  (if false #_(session/has-feature-access? :feature/esign-v2)
      [default-page-layout/view
       [component]]
      [not-found/not-found-view]))

